<template>
  <div id="sale-screen" style="height: 100vh" v-show="isAuth">
    <top-of-the-day-screen ref="topofthedayscreenref" @emitGetBranchOpenClose="getOpenClose"/>
    <day-interim-screen ref="dayinterimscreenref" @emitDisable="emitDisableSelfService"></day-interim-screen>
    <day-close-screen  ref="dayclosescreenref" @emitCloseReport="emitCloseReportSelfService"></day-close-screen>
    <total-order-logs-popup ref="totalOrderLogsPopup"/>
    <safe-cash-entry ref="safeCashEntryPopup"></safe-cash-entry>
    <new-expense-add-for-self-service
      ref="newExpenseAdd"
      @saveExpense="saveExpense"
      @updateExpense="false"
      @close="selected = {}"
    />
    <personal-reviewer
      v-if="activePersonal"
      :userId="activePersonal.id"
      :isActive="isPersonalReviewerActive"
      @close="isPersonalReviewerActive = false"
    />
    <vs-popup
      :active.sync="isActiveChangePassword"
      id="changePassword"
      :title="
        activePersonal != null
          ? activePersonal.name
          : null + 'Satış Ekranı Kodu Değiştir'
      "
    >
      <vs-row vs-type="flex" vs-w="12" class="p-5">
        <vs-input
          id="oldCode"
          name="Eski Kod"
          class="w-full"
          icon-pack="feather"
          icon="icon-lock"
          label-placeholder="Eski Kod"
          v-model="newUserCodeObj.oldCode"
          type="password"
          v-validate="{ required: true, digits: 4 }"
        />
        <span class="text-danger text-sm" v-show="errors.has('Eski Kod')">{{
            errors.first("Eski Kod")
          }}</span>

        <vs-input
          id="newCodeInput"
          ref="newCodeInput"
          name="Yeni Kod"
          class="w-full"
          icon-pack="feather"
          icon="icon-shield"
          label-placeholder="Yeni Kod"
          v-model="newUserCodeObj.newCode"
          type="password"
          v-validate="{ required: true, digits: 4 }"
        />
        <span class="text-danger text-sm" v-show="errors.has('Yeni Kod')">{{
            errors.first("Yeni Kod")
          }}</span>

        <vs-input
          id="newCodeRetryInput"
          name="Yeni Kod Tekrar"
          class="w-full"
          icon-pack="feather"
          icon="icon-shield"
          label-placeholder="Yeni Kod Tekrar"
          type="password"
          v-model="newUserCodeObj.newCodeRet"
          v-validate="'required: true|confirmed:newCodeInput|digits:4'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Yeni Kod Tekrar')"
        >{{ errors.first("Yeni Kod Tekrar") }}</span
        >

        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start">
            <vs-button
              @click="isActiveChangePassword = false"
              icon-pack="feather"
              type="gradient"
              color="danger"
              class="bold"
              icon="icon-arrow-left"
            >
              Vazgeç
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
            <vs-button
              @click="changePassword"
              color="transparent"
              class="bg-success text-white bold"
            >
              Onayla
            </vs-button>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-popup>
    <vs-popup :active.sync="isSafeOperations" title="Kasa İşlemleri">
    <vs-row vs-type="flex" vs-w="12" class="p-2" vs-align="center" vs-justify="center">
  <vs-button style="width: 80%;" @click="
  isSafeOperations = false;
  addNewExpense();
  " color="transparent" class="bg-success text-white bold" >Nakit Çıkışı</vs-button>
</vs-row>

<vs-row vs-type="flex" vs-w="12" class="p-2" vs-align="center" vs-justify="center">
  <vs-button @click="$refs.safeCashEntryPopup.isActive = true;" style="width: 80%;"color="transparent" class="bg-success text-white bold" >Nakit Girişi</vs-button>
</vs-row>

<vs-row vs-type="flex" vs-w="12" class="p-2" vs-align="center" vs-justify="center">
  <vs-button :disabled="true" style="width: 80%;"  color="transparent" class="bg-success text-white bold">Kasa Açılış</vs-button>
</vs-row>

<vs-row vs-type="flex" vs-w="12" class="p-2" vs-align="center" vs-justify="center">
  <vs-button  id="araRaporButton" @click="$refs.dayinterimscreenref.isActive = true;" style="width: 80%;" color="transparent" class="bg-success text-white bold" >Ara Rapor</vs-button>
</vs-row>

<vs-row vs-type="flex" vs-w="12" class="p-2" vs-align="center" vs-justify="center">
  <vs-button @click="dayCloseClick" style="width: 80%;" color="transparent" class="bg-success text-white bold">Gün Sonu</vs-button>
</vs-row>

</vs-popup>

<vs-popup :active.sync="isTimerEffect" title="Kapanış Saati">
  <h3>Kapanış Saatine Az Kaldı</h3>
    <vs-row vs-type="flex" vs-w="12" class="p-2" vs-align="center" vs-justify="center">
      <vs-col vs-type="flex" vs-w="6">
        <vs-button style="width: 80%;" @click="
  isTimerEffect = false;
  $refs.dayclosescreenref.isOldClose = false;
  $refs.dayclosescreenref.isActive = true;
  " color="transparent" class="bg-success text-white bold" >Kapanış Yap</vs-button>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <vs-button style="width: 80%;" @click="
  isTimerEffect = false;
  " color="transparent" class="bg-success text-white bold" >Ertele</vs-button>
</vs-col>

</vs-row>

</vs-popup>


    <switch-account v-if="isAuth"/>
    <transition name="slide-fade">
      <div v-if="toggleProfileActions" class="bg-secondary profile-actions">
        <vs-row
          v-show="profileActionPage == 0"
          vs-type="flex"
          vs-w="12"
          vs-justify="space-between"
        >
          <vs-col vs-type="flex" vs-w="1">
            <vs-button
              @click="profileActionPage = profileActionPage - 1"
              class="w-full text-primary"
              color="transparent"
              icon-pack="feather"
              type="flat"
              icon="icon-chevron-left"
            />
          </vs-col>
          <vs-col
            v-if="this.isPosEnabled&&!isRequestActive"
            vs-type="flex"
            vs-w="3.5"
            vs-justify="center"
          >
            <vs-button
              @click="connectPos(true)"
              class="bg-secondary text-primary h5"
              color="transparent"
              type="flat"
              radius
              icon-pack="feather"
              icon="icon-printer"
            >Cihaza Bağlan
            </vs-button>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-w="3"
            vs-justify="center"
            v-if="isAdminActivePersonal"
          >
            <vs-button
              @click="
                isActiveTotalOrderLogs = true;
                resetProfileSelection();
              "
              class="bg-secondary text-primary h5"
              color="transparent"
              type="flat"
              radius
              icon-pack="feather"
              icon="icon-activity"
            >Anlık Ciro
            </vs-button>
          </vs-col>
          <vs-col v-if="dayReportIsEnable" vs-type="flex" vs-w="2.5" vs-justify="center">
            <vs-button
      @click="toggleDropdown"
      class="bg-secondary text-primary h5"
      color="transparent"
      type="flat"
      radius
      icon-pack="feather"
      icon="icon-dollar-sign"
    >
      Kasa İşl.
    </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" vs-justify="center">
            <vs-button
              @click="isPersonalReviewerActive = true"
              class="bg-secondary text-primary"
              color="transparent"
              type="flat"
              radius
              icon-pack="feather"
              icon="icon-book-open"
            >
              Hedeflerim
            </vs-button>
          </vs-col>

          <vs-col vs-type="flex" vs-w="1">
            <vs-button
              @click="profileActionPage = profileActionPage + 1"
              class="w-full text-primary"
              color="transparent"
              type="flat"
              icon-pack="feather"
              icon="icon-chevron-right"
            />
          </vs-col>
        </vs-row>

        <vs-row
          v-show="profileActionPage == 1"
          vs-type="flex"
          vs-w="12"
          vs-justify="space-between"
        >
          <vs-col vs-type="flex" vs-w="1">
            <vs-button
              @click="profileActionPage = profileActionPage - 1"
              class="w-full text-primary"
              color="transparent"
              icon-pack="feather"
              type="flat"
              icon="icon-chevron-left"
            />
          </vs-col>

          <vs-col vs-type="flex" vs-w="2" vs-justify="center">
            <vs-button
              class="bg-secondary text-primary"
              color="transparent"
              type="flat"
              radius
              icon-pack="feather"
              icon="icon-user"
            >
              Profilim
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="3" vs-justify="center">
            <vs-button
              @click="
                isActiveChangePassword = true;
                resetProfileSelection();
              "
              class="bg-secondary text-primary h5"
              color="transparent"
              type="flat"
              radius
              icon-pack="feather"
              icon="icon-lock"
            >Şifre Değiştir
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" vs-justify="center">
            <vs-button
              @click="
                doExit();
                resetProfileSelection();
              "
              class="bg-secondary text-primary"
              color="transparent"
              type="flat"
              radius
              icon-pack="feather"
              icon="icon-log-out"
            >Çıkış
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" vs-justify="center">
            <vs-button
              @click="
                openCustomerScreen();
              "
              class="bg-secondary text-primary"
              color="transparent"
              type="flat"
              radius
              icon-pack="feather"
              icon="icon-log-out"
            >Müşteri Ekranı
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="1">
            <vs-button
              @click="profileActionPage = profileActionPage + 1"
              class="w-full text-primary"
              color="transparent"
              type="flat"
              icon-pack="feather"
              icon="icon-chevron-right"
            />
          </vs-col>
        </vs-row>
      </div>
    </transition>
    <div id="main-base">
      <vs-row vs-type="flex" vs-w="12" id="head-content">
        <product-variant-selection
          ref="variantSelection"
          @closeProductSelection="closeProductSelection"
          @productSelectionCompleted="productSelectionCompleted"
        ></product-variant-selection>
      </vs-row>
      <vs-row id="main-content" style="height: 100%" vs-type="flex" vs-w="12">
        <vs-col id="product-list" vs-w="7" style="height: 100%">
          <product-list-page
            v-if="productList != null"
            v-show="
              !isProductVariantSelectionOpen &&
              toUpdateEntry == null &&
              selectedProduct == null
            "
            :productList="productList"
          ></product-list-page>
          <cart-entry
            v-if="
              toUpdateEntry != null ||
              (selectedProduct != null && preSelectedProduct == null)
            "
          ></cart-entry>
        </vs-col>
        <vs-col vs-type="block" vs-w="5">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" class="mb-1">
              <vs-button
                class="profile-button w-full p-0 bg-white text-primary half-friendly-border sale-box-shadow"
                color="transparent"
              >
                <vs-row vs-type="flex" vs-w="12">
                  <vs-col vs-type="flex" vs-w="3" class="py-1 px-1">
                    <vs-button
                      class="half-friendly-border w-full p-0"
                      :class="{
                        'sale-unlock-button': isScreenLock == false,
                        'sale-lock-button bg-primary2': isScreenLock == true,
                      }"
                      @click="screenLockToggle"
                      color="transparent"
                    >
                      <i
                        class="vs-icon feather"
                        :class="{
                          'icon-unlock': isScreenLock == false,
                          'icon-lock': isScreenLock == true,
                        }"
                      ></i>
                    </vs-button>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-w="3"
                    vs-align="center"
                    v-if="activePersonal"
                  >
                    <vs-row vs-type="flex" vs-w="12">
                      <vs-row vs-type="flex" vs-w="12">
                        <p class="w-full active-user-name">
                          {{ activePersonal.name }}
                        </p>
                      </vs-row>
                      <vs-row vs-type="flex" vs-w="12">
                        <p class="w-full active-user-role">
                          {{ activePersonal.role[0].name }}
                        </p>
                      </vs-row>
                    </vs-row>
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="3" vs-justify="center">
                    <vs-row vs-type="flex" vs-w="12">
                      <vs-row vs-type="flex" vs-w="12">
                          <vs-button vs-w="12" style="width: 14rem; margin-bottom: 0.5rem; margin-top: 0.5rem"
                @click="
                    doExit();
                    resetProfileSelection();
                "
                class="bg-secondary text-primary"
                color="danger"
                icon-pack="feather"
                icon="icon-log-out"
            >Çıkış
            </vs-button>
                      </vs-row>
                      <vs-row v-if="isAddLoss"  vs-type="flex" vs-w="12">
                          <vs-button style="width: 14rem;" vs-w="12"
                          @click="
                lossMode = true;
                resetProfileSelection();
              "
                class="bg-secondary text-primary"
                color="warning"
                icon-pack="feather"
                icon="icon-trash"
            >Zayiat
            </vs-button>
                      </vs-row>
                    </vs-row>
</vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-w="3"
                    vs-justify="flex-end"
                    v-if="activePersonal"
                  >
                    <radial-progress-bar
                      :diameter="95"
                      :completed-steps="20"
                      :total-steps="100"
                    >
                      <img
                        :src="getAvatar(activePersonal.imageUrl)"
                        class="responsive circle py-1 px-1"
                        @click="toggleProfileActions = !toggleProfileActions"
                      />
                    </radial-progress-bar>
                  </vs-col>
                </vs-row>
              </vs-button>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" id="carts">
              <cart-order ref="cartOrder"/>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script>
import PersonalReviewer from "../PersonalReviewer.vue";
import TotalOrderLogsPopup from "./TotalOrderLogsPopup.vue";
import Cookies from "js-cookie";
import CookieKeys from "@/model/constants/cookieKeys";
import RadialProgressBar from "vue-radial-progress";
import SwitchAccount from "./SwitchAccount.vue";
import CartOrder from "./CartOrder.vue";
import ProductListPage from "./ProductListPage";
import ProductVariantSelection from "./ProductVariantSelection";
import CartEntry from "./CartEntry";
import selfServiceStore from "@/store/selfService/selfService.js";
import {navigationQuestionForRedirect, getPosSettings} from "@/api/AppSettings";
import {getCategoryAndProduct} from "@/api/ProductCategory";
import {fetchUserWithCodes} from "@/api/User";
import {fetchLastBillId, changePassword} from "@/api/SelfService";
import {getPaymentMethodList} from "@/api/PaymentMethod";
import companyInfo from "../../../model/constants/companyInfo";
import NewExpenseAddForSelfService from "./NewExpenseAddForSelfService.vue";
import TopOfTheDayScreen from "./TopOfTheDayScreen.vue";
import {isGranted} from "@/utils/auth";

import DayInterimScreen from "./DayInterimScreen.vue";
import {
  getIsDayOpening,getIsDayInterim,getBranchOpenClose,getRealTime
  } from "@/api/DayOpen.js";
import DayCloseScreen from "./DayCloseScreen.vue";
import { getDayReportEnable } from "../../../api/DayReportSetting";
import SafeCashEntry from "./SafeCashEntry.vue";
export default {
  components: {
    ProductListPage,
    ProductVariantSelection,
    CartEntry,
    CartOrder,
    SwitchAccount,
    RadialProgressBar,
    TotalOrderLogsPopup,
    PersonalReviewer,
    NewExpenseAddForSelfService,
    TopOfTheDayScreen,
    DayInterimScreen,
    DayCloseScreen,
    SafeCashEntry
},
  data() {
    return {
      isSafeOperations: false,
      isPersonalReviewerActive: false,
      profileActionPage: 0,
      newUserCodeObj: {},
      isRequestActive: false,
      isAuth: false,
      isPosEnabled: false,
      isActiveChangePassword: false,
      toggleProfileActions: false,
      screenLock: true,
      cartEntry: null,
      productList: null,
      time: null,
      logo: companyInfo.logo,
      openClose:{},
      timerId: null,
      isTimerEffect : false,
      dayReportIsEnable : false
    };
  },
  computed: {
    isAddLoss(){
      return isGranted("discount_loss_create")
    },
    isOrderListActive() {
      return this.$refs.cartOrder && this.$refs.cartOrder.isOrderListActive;
    },
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    isActiveTotalOrderLogs: {
      get() {
        return this.$refs.totalOrderLogsPopup.isActive;
      },
      set(val) {
        this.$refs.totalOrderLogsPopup.isActive = val;
      },
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    isProductVariantSelectionOpen: {
      get() {
        return this.$refs.variantSelection
          ? this.$refs.variantSelection.isProductVariantSelectionOpen
          : null;
      },
      set(val) {
        this.$refs.variantSelection.isProductVariantSelectionOpen = val;
      },
    },
    preSelectedProduct() {
      return this.$store.getters["selfservice/getPreSelectedProduct"];
    },
    selectedProduct() {
      return this.$store.getters["selfservice/getSelectedProduct"];
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    isTopDay: {
      get() {
        return true;
      },
      set(val) {
        // this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    activePersonal: {
      get() {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },
    isAdminActivePersonal() {
      return this.activePersonal.role.some((x) => x.name == "admin");
    },
  },
  watch: {
    profileActionPage(newVal, oldVal) {
      if (newVal < 0 || newVal > 1) this.profileActionPage = oldVal;
    },
    isActiveChangePassword(val) {
      this.newUserCodeObj = {};
    },
    preSelectedProduct: function (val) {
      if (val != null) {
        this.isProductVariantSelectionOpen = true;
      } else {
        this.isProductVariantSelectionOpen = false;
      }
    },
    lossMode(val) {
      this.isReset = true;
    },
  },
  methods: {
    openCustomerScreen() {
      // İkinci monitörün genellikle birinci monitörün sağında olduğunu varsayarak:
    const primaryScreenWidth = window.screen.width;

    // İkinci monitörde tam ekran açmak için:
    const features = `fullscreen=yes,menubar=no,toolbar=no,location=no,status=no,left=${primaryScreenWidth},top=${window.screen.height},width=0,height=0`;

    window.open('/pages/customer-screen','Lütfen ekrana tıklayınız...', features);
    },
    getOpenClose:async function(){
      this.openClose = (await getBranchOpenClose()).data;
    },
    dayCloseClick(){
      this.$refs.dayclosescreenref.isOldClose = false;
      this.$refs.dayclosescreenref.isActive = true;
      // clearInterval(this.timerId)
    },
    checkClosingTime: async function () {
      await this.getOpenClose();
      var remoteDate = await getRealTime();
      const currentTime = new Date(remoteDate.data);
      const targetTime = new Date();
      const currentTimeMinutes = currentTime.getHours() * 60 + currentTime.getMinutes();
      const targetTimeMinutes = parseInt(this.openClose.closeTime.split(":")[0]) * 60 + parseInt(this.openClose.closeTime.split(":")[1]);
      //console.log(this.openClose.openDate);
      let timeDifference = targetTimeMinutes - currentTimeMinutes;
      let closeTime = new Date(this.openClose.openDate);
      let openTime = new Date(this.openClose.openDate);
      closeTime.setHours(parseInt(this.openClose.closeTime.split(":")[0]), parseInt(this.openClose.closeTime.split(":")[1]), 0);
      openTime.setHours(parseInt(this.openClose.openTime.split(":")[0]), parseInt(this.openClose.openTime.split(":")[1]), 0);
      console.log(currentTime);
      console.log(closeTime);
      console.log(openTime);
      if (openTime.getTime() > closeTime.getTime()) {
        // Eğer kapanış saati 24'ten sonrasa, hedef zamanı bir sonraki gün olarak ayarla
        closeTime.setDate(currentTime.getDate() + 1);
      }
      timeDifference = closeTime.getTime() - currentTime.getTime();
      if (timeDifference <= 600000 ) {
        // Kapatma saati yaklaşıyor, popup'ı göster
        this.isTimerEffect = true;
      } else {
        // Kapatma saati uzak, popup'ı gizle
        this.isTimerEffect = false;
      }
    },
    emitCloseReportSelfService(result){
      if(result){
        this.$refs.topofthedayscreenref.isActive = true;
      }
    },
    emitDisableSelfService(result){
      if(result){
       // document.getElementById('araRaporButton').disabled = true;
      }
    },
    saveExpense(payload) {
      this.$store.dispatch("expense/addExpense", payload).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error,
        });
      });
    },
    addNewExpense() {
      this.$refs.newExpenseAdd.isActive = true;
    },
    toggleDropdown() {
      this.isSafeOperations = !this.isSafeOperations;
    },
    getAvatar(image) {
      if (image == "") return this.logo;
      else return this.$baseUrl + "/" + image;
    },
    resetProfileSelection() {
      this.toggleProfileActions = false;
      this.profileActionPage = 0;
    },
    changePassword: async function () {
      let check = await this.$validator.validateAll();
      if (!check) return;
      if (this.activePersonal.userCode != this.newUserCodeObj.oldCode) {
        this.$fire({
          title: "Hata !",
          text: "Eski Kod Aktif Kullanıcının Kodu ile Eşleşmiyor !",
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Eski Kod Aktif Kullanıcının Kodu ile Eşleşmiyor !",
        });
      } else {
        changePassword({
          userId: this.activePersonal.id,
          userCode: this.newUserCodeObj.newCode,
        })
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Kod Başarıyla Değiştirildi !",
                text: "Yeni Kod Kullanıma Hazır.",
              });
              this.isActiveChangePassword = false;
              this.$store.dispatch(
                "selfservice/setActivePersonalUserCode",
                this.newUserCodeObj.newCode
              );
            }
          })
          .catch((x) => {
            this.$fire({
              title: "Hata !",
              text: "Kod Değiştirme Başarısız !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Kod Değiştirme Başarısız !",
            });
          });
      }
    },
    doExit() {
      //let userDetails = Cookies.get(CookieKeys.USER_DETAILS)
      //if(USER_DETAILS.rols.some(x=> x.name == Roles.admin))
      //this.$router.push('/');
      //else {
      this.$router.push("/pages/login");

      // }
      // document.exitFullscreen();
    },
    screenLockToggle() {
      if (!this.isOrderListActive) {
        this.activePersonal = null;
      }
    },
    onSelectProduct(val) {
      this.preSelectedProduct = val;
      this.isProductVariantSelectionOpen = true;
    },
    productSelectionCompleted: function (val) {
      this.cartEntry = val;
      // this.$store.dispatch("productSelectionCompleted",true);
      //Add To Cart
      this.isProductVariantSelectionOpen = false;
      this.$store.dispatch("selfservice/setPreSelectedProduct", null);
    },
    closeProductSelection: function () {
      this.isProductVariantSelectionOpen = false;
    },
    fetchCategories: async function () {
      try {
        this.productList = await getCategoryAndProduct();
      } catch (e) {
        this.productList = null;
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    fetchUsers: async function () {
      try {
        let response = await fetchUserWithCodes();
        this.$store.dispatch("selfservice/setPersonList", response);
      } catch (e) {
        this.$store.dispatch("selfservice/setPersonList", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    fetchLastBillId: async function () {
      try {
        let response = await fetchLastBillId();
        this.$store.dispatch("selfservice/setLastBillId", response + 1);
      } catch (e) {
        this.$store.dispatch("selfservice/setLastBillId", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    getPaymentMethodList: async function () {
      try {
        let response = await getPaymentMethodList();
        response[0].selected = true;
        this.$store.dispatch("selfservice/setPaymentMethods", response);
      } catch (e) {
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    inactivityTime() {
      window.onload = this.resetTimer;
      document.onmousemove = this.resetTimer;
      document.onkeypress = this.resetTimer;
      document.onclick = this.resetTimer;
    },
    resetTimer() {
      if (this.activePersonal !== null) {
        clearTimeout(this.time);
        this.time = setTimeout(this.screenLockToggle, this.$afkTimeOut);
      }
    },
    getNavigationQuestionForSale: async function () {
      try {
        let response = await navigationQuestionForRedirect();
        this.$store.dispatch("selfservice/setNavigationQuestion", response);
      } catch (e) {
        this.$store.dispatch("selfservice/setNavigationQuestion", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    connectPos: async function (loadScreen) {
      this.isRequestActive = true;
      this.isLoading = loadScreen;
      await fetch(process.env.VUE_APP_POS_API + "pair", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }).then((response) => response.json())
        .then((res) => {
          this.isRequestActive = false;
          this.isLoading = false;
          if (res.hasError == false || res.statusCode == 200) {
            this.$vs.notify({
              color: "success",
              title: "Pos Cihazına Bağlanıldı.",
              text: "",
            });
          } else if (res.message.includes("Cihaz Bağlantısı yapıldı")) {
            this.$vs.notify({
              color: "success",
              title: "Pos Cihaz Bağlantısı Yapıldı!",
              text: res.message,
            });
          } else {
            this.$fire({
              title: "Hata !",
              text: "Pos Cihaz Bağlantısı Yapılamadı !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Pos Cihaz Bağlantısı Yapılamadı !",
              text: res.message,
            });
          }
        })
        .catch((x) => {
          this.isRequestActive = false;
          this.isLoading = false;
          this.$fire({
            title: "Hata !",
            text: "Pos Cihaz Bağlantısı Yapılamadı !",
            type: "error"
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Pos Cihaz Bağlantısı Yapılamadı !",
          });
        });
    },
    checkPosDevice: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      if (!userInfo) {
        this.$router.push("/");
      }
      let branchId = await userInfo.branch.id
      let axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
    },
  },
  created: async function () {
    this.productList = null;
    await  this.checkPosDevice();
    if (this.isPosEnabled) this.connectPos(false);
    this.fetchCategories();
    this.fetchUsers();
    this.fetchLastBillId();
    this.getPaymentMethodList();
    this.getNavigationQuestionForSale();
    let checkAuth = Cookies.get(CookieKeys.AUTH_KEY);
    checkAuth? this.isAuth=true: this.$router.push('/pages/login');
    this.isScreenLock = false;
    this.dayReportIsEnable = (await getDayReportEnable()).data;
    console.log(this.dayReportIsEnable);
    await this.getOpenClose();
    console.log(this.openClose);

    if (this.dayReportIsEnable) {
      let isDayOpening = await getIsDayOpening();
    if (isDayOpening.data == 0) {

      this.$refs.topofthedayscreenref.isActive = true;
    }
    if (isDayOpening.data == 1) {
      this.$refs.dayclosescreenref.isOldClose = true;
      console.log(this.openClose);
      this.$refs.dayclosescreenref.lastOpenDate = this.openClose.lastOpenDate;
      this.$refs.dayclosescreenref.isActive = true;
    }
    let isDayInterim = await getIsDayInterim();
    if(isDayInterim.data){
      //document.getElementById('araRaporButton').disabled = true;
    }
      this.timerId = await setInterval(this.checkClosingTime, 120000);
    }
    this.inactivityTime();
  },
  beforeCreate: function () {
    if (!selfServiceStore.isRegistered) {
      this.$store.registerModule("selfservice", selfServiceStore);
      selfServiceStore.isRegistered = true;
    }
  },
};
</script>
<style>
.profile-actions {
  position: absolute;
  width: 41.7vw;
  right: 0vw;
  top: 6rem;
  z-index: 100;
  border-bottom-left-radius: 1rem !important;
  border-bottom-right-radius: 1rem !important;
  box-shadow: 0px 3px 6px #00000029;
}

#main-base {
  z-index: 3;
  height: 100%;
}

.profile-actions .vs-row .vs-col button i {
  font-size: 1.5rem !important;
}

.active-user-name {
  font-weight: 600;
  font-size: 1.2rem !important;
}

.active-user-role {
  font-weight: normal !important;
  font-style: italic;
}

.profile-button .vs-button-text {
  width: 100% !important;
}

.profile-button {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.overlay {
  border-radius: 50px !important;
}

#carts {
  height: calc(99vh - 95.5px) !important;
}

@media screen and (max-width: 1100px) {
  .sale-lock-button .icon-lock {
    font-size: 6vw !important;
  }

  .sale-unlock-button .icon-unlock {
    font-size: 6vw !important;
  }
}

@media screen and (min-width: 1101px) {
  .sale-lock-button .icon-lock {
    font-size: 4rem !important;
  }

  .sale-unlock-button .icon-unlock {
    font-size: 4rem !important;
  }
}

.sale-lock-button {
  max-width: 125px;
  color: rgb(241, 241, 241) !important;
  text-shadow: 1px 1px 5px black !important;
  padding: 0.75rem !important;
}

.sale-unlock-button {
  max-width: 125px;
  background: #56ab2f !important;
  background: -webkit-linear-gradient(to right, #7ab335, #56ab2f) !important;
  background: linear-gradient(to right, #7ab335, #3a8a16) !important;
  color: rgb(241, 241, 241) !important;
  text-shadow: 1px 1px 5px black !important;
}

.vs-table--not-data {
  display: none;
}


#sale-screen {
  z-index: 0;
}

.vs-button-border.isActive .vs-button--icon,
.vs-button-border.isActive .vs-button--text,
.vs-button-flat.isActive .vs-button--icon,
.vs-button-flat.isActive .vs-button--text {
  color: unset !important;
}

#printJS {
  top: 0 !important;
}
.swal2-container {
  z-index: 99999;
}
</style>
